import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Text, View, TouchableOpacity } from 'react-native';

import { styles } from './Styles';
import { RadioButton } from '../../ui';
import Theme from '../../theme';

const BodyGroupSection = ({
  isActive,
  title,
  subtitle,
  onPress,
  disableCustomize,
}) => (
    <TouchableOpacity onPress={onPress} style={styles.bodyGroupButton}>
        <View style={styles.settingCheckboxContainer}>
            <View style={styles.bodyRadioButtonContainer}>
              <RadioButton
                disabled={disableCustomize}
                isSelected={isActive}
                toggleSelection={onPress}
              />
            </View>
        </View>
        <View>
          <Text style={[styles.settingsTitle, disableCustomize &&  { color: Theme.GREY_MEDIUM }]}>{title}</Text>
          <Text style={styles.settingsSubtitle}>{subtitle}</Text>
        </View>
      </TouchableOpacity>
  );

BodyGroupSection.propTypes = {
  isActive: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  cardioOrResistance: PropTypes.string.isRequired,
  disableCustomize: PropTypes.bool.isRequired,
};

export default translate(['bookings'], { wait: true })(BodyGroupSection);
